export enum ConsultationRequestStatusType {
    Pending = 1,
    Assigned = 2,
    Confirm = 3,
    Reject = 4,
    Closed = 5,
    Release = 6,
    Arrive = 7,
}
